var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColorSwatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    color: "#262A3E",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.color-swatch-dot-svg{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}\n\t.color-swatch-svg{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "color-swatch-dot-svg",
    d: "M5.5,12c0,0.3-0.2,0.5-0.5,0.5S4.5,12.3,4.5,12s0.2-0.5,0.5-0.5S5.5,11.7,5.5,12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "color-swatch-svg",
    d: "M0.8,2.8c0-1.1,0.9-2,2-2h4.5c1.1,0,2,0.9,2,2v10.5c0,1.1-0.9,2-2,2H2.8c-1.1,0-2-0.9-2-2V2.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "color-swatch-svg",
    d: "M11.7,11.2l2.9-3c0.8-0.8,0.8-2,0-2.8l-3.1-3.3c-0.8-0.8-2.4-0.4-2.4-0.4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorSwatch);
export default __webpack_public_path__ + "static/media/color-swatch.be0548550059ec02392a0b7c180a9ed1.svg";
export { ForwardRef as ReactComponent };